export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["IDLE"] = "idle";
    RequestStatus["PENDING"] = "pending";
    RequestStatus["FULFILLED"] = "fulfilled";
    RequestStatus["REJECTED"] = "rejected";
})(RequestStatus || (RequestStatus = {}));
